export class VerifyFirebaseToken {
    firebaseToken: string;
    uid: string;
    userId: string;

    constructor(fbToken : string,uid: string,userId: string){
        this.firebaseToken = fbToken;
        this.uid = uid;
        this.userId = userId;
    }
}